export default __webpack_public_path__ + "static/media/report-partner.60a0f699.png";